/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgDockerBoilerplate = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M9.695 9.402H7.994V7.856h1.701zm2.01.31h-1.7v1.546h1.7zm-2.01 0H7.994v1.546h1.701zm2.01-1.856h-1.7v1.546h1.7zM13.717 6h-1.701v1.547h1.701zm2.01 3.712h-1.7v1.546h1.7zm-2.01 0h-1.701v1.546h1.701zm0-1.856h-1.701v1.546h1.701zM7.685 9.712H5.983v1.546h1.702zm2.474 7.733c4.055 0 7.045-1.873 8.454-5.259.55.017 1.736 0 2.355-1.168l.154-.31.052-.12-.344-.223c-.378-.24-1.22-.344-1.89-.224-.086-.618-.43-1.151-1.065-1.632l-.327-.258-.24.361c-.31.464-.464 1.1-.413 1.718.017.224.086.602.31.946-.224.12-.67.292-1.255.274H4.78l-.017.138c-.103.619-.103 2.56 1.152 4.038.945 1.152 2.388 1.719 4.244 1.719z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgDockerBoilerplate as DockerBoilerplate };
